export const Heading = {
  baseStyle: {
    fontFamily: 'OPPOSans',
  },
}
